import { Component, ElementRef, ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import * as Hammer from 'hammerjs';

@Component({
    selector: 'app-image-zoom',
    template: `
        <div #zoomElement class="zoom-container" [style]="'touch-action: {{touchActionOverride}}'" >
            <img #imageElement alt="{{altText}}" class="zoom-image" src="{{imageUrl}}" loading="lazy"/>
        </div>`,
    standalone: true,
    styles: [`
        .zoom-container {
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .zoom-image {
            transition: transform 0.2s ease-out;
            width: 100%;
            height: auto;
            max-height: 100%;
        }
    `]
})
export class ZoomComponent implements AfterViewInit {
    @ViewChild('zoomElement') zoomElement!: ElementRef;
    @ViewChild('imageElement') imageElement!: ElementRef;
    @Input() imageUrl: string;
    @Input() touchActionOverride: string = "none";
    @Input() altText: string = "";

    @Output() zoomActive: EventEmitter<boolean> = new EventEmitter();

    private scale = 1;
    private lastScale = 1;
    private translateX = 0;
    private translateY = 0;
    private lastTranslateX = 0;
    private lastTranslateY = 0;
    private hammer!: HammerManager;

    ngAfterViewInit() {
        const el = this.zoomElement.nativeElement;
        const img = this.imageElement.nativeElement;

        this.hammer = new Hammer.Manager(el, {
            touchAction: this.touchActionOverride, // or leave it blank and set style manually like above
        });

        // Enable pinch and pan gestures
        const pinch = new Hammer.Pinch();
        const pan = new Hammer.Pan({ threshold: 0 });

        this.hammer.add([pinch, pan]);

        // Handle pinch-to-zoom
        this.hammer.on('pinch', (ev) => {
            this.scale = Math.max(1, Math.min(3, this.lastScale * ev.scale));
            this.applyTransform(img);
        });

        this.hammer.on('pinchend', (ev) => {
            this.lastScale = this.scale;
            this.zoomActive.emit(true);
        });

        // Handle panning
        this.hammer.on('pan', (ev) => {
            if (this.scale > 1) {  // Allow panning only when zoomed in
                this.translateX = this.lastTranslateX + ev.deltaX;
                this.translateY = this.lastTranslateY + ev.deltaY;
                this.applyTransform(img);
            }
            if (this.scale <= 1) {
                this.resetTransform()
            }
        });

        this.hammer.on('panend', (event) => {
            this.lastTranslateX = this.translateX;
            this.lastTranslateY = this.translateY;
            // für swipe muss nach panend nochmal gecheckt werden.
            if (this.scale <= 1) {
                this.resetTransform()
            }
            else {
                this.zoomActive.emit(true);
            }
        });
    }

    private applyTransform(img: HTMLElement) {
        img.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
        this.zoomActive.emit(true);
        this.zoomElement.nativeElement.style.touchAction = this.scale > 1 ? 'none' : this.touchActionOverride;
    }

    // nicht funktionierende Begrenzung von translate x und y

    // private applyTransform(img: HTMLImageElement) {
    //     const containerRect = this.zoomElement.nativeElement.getBoundingClientRect();
    //     const imgRect = img.getBoundingClientRect();
    //
    //     const naturalWidth = img.naturalWidth || imgRect.width / this.scale;
    //     const naturalHeight = img.naturalHeight || imgRect.height / this.scale;
    //
    //     const scaledWidth = naturalWidth * this.scale;
    //     const scaledHeight = naturalHeight * this.scale;
    //
    //     // The "overflow" beyond the container
    //     const overflowX = Math.max(0, (scaledWidth - containerRect.width ) / 2);
    //     const overflowY = Math.max(0, (scaledHeight - containerRect.height) / 2);
    //
    //     // Clamp translate values so image can't move out of bounds
    //     this.translateX = Math.min(overflowX, Math.max(-overflowX, this.translateX));
    //     this.translateY = Math.min(overflowY, Math.max(-overflowY, this.translateY));
    //
    //     img.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
    //
    //     this.zoomActive.emit(true);
    //     this.zoomElement.nativeElement.style.touchAction =
    //         this.scale > 1 ? 'none' : this.touchActionOverride;
    // }


    resetTransform() {
        this.translateX = 0;
        this.translateY = 0;
        this.applyTransform(this.imageElement.nativeElement);
        this.zoomActive.emit(false);
        this.zoomElement.nativeElement.style.touchAction = this.scale > 1 ? 'none' : this.touchActionOverride;
    }

    ngOnDestroy() {
        if (this.hammer) {
            this.hammer.stop(true);
            this.hammer.destroy();
        }
    }

}
